export const resendCounterTime = 300;
export const USER_IDLE_TIME = 30 * 60 * 1000;
export const BASE_URL = window.location.origin;
export const BACKEND_URL = process.env.REACT_APP_APIBASE;

export const withoutDefaultParams = "withoutDefaultParams";

export const noticeBoardLoginParam = "noticeboard-login";

export const imageFormats = [".png", ".jpeg", ".jpg", ".pdf", ".doc", ".docx", ".xlse", ".csv"];

export const questionTypes = [
  { label: "Text", value: "text" },
  { label: "Paragraph", value: "textarea" },
  // { label: "File", value: "file" },
  { label: "Date", value: "date" },
  { label: "Date-Time", value: "datetime-local" },
];

export const emailRegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gm;

export const editorFontSizes = ["16px", "18px", "24px", "30px", "36px", "48px", "60px", "72px", "96px", "105px", "110px", "115px"];

export const openAiTemplate = `
You are a professional report writer for an NDIS service provider in New South Wales, Australia. 
Your role is to transform raw progress notes written by Support Workers into a clear, concise, and professional stakeholder report.

INPUT:
- Progress notes for a specific client.
- Date range for the report.
- Client’s first name, NDIS goals, and relevant background context.

TASK:
Generate a professional stakeholder report including:

FORMAT & STRUCTURE:
- Title page or header: Client Name, Report Type, and Date Range.
- Introduction (1–2 paragraphs): Purpose of the report and general overview of client wellbeing.
- Thematic Sections:
  - Health and Wellbeing
  - Recreational Activities
  - Meals
  - Day Program Details
  - Appointments and Therapies Attended
  - Time of Services for Each Day (Social Support)
  - Medication Administration
  - Sleep Patterns
  - Travel Details
  - Other Notable Observations
- Achievements and Positive Progress
- Challenges or Concerns
  - Behaviours of Concern Reported
  - Incidents Reported
  - Other Challenges or Concerns
- Recommendations / Next Steps
- Closing Summary

TONE & STYLE:
- Professional, respectful, and objective.
- No jargon or unnecessary abbreviations.
- Synthesize notes; do not copy verbatim.
- Focus on progress toward client goals.
- Supportive, person-centred perspective.

NDIS/COMPLIANCE:
- Observations must be factual and neutral.
- Avoid subjective or judgmental language.
- Maintain confidentiality: use only first name.
`;

export const deleteLogParam = "deletionLog";

export const partMedicineField = {
  medicine_id: "",
  prescriber: "",
  strength: "",
  form: "",
  route: "",
  medicine_to_date: "",
  medicine_from_date: "",
  medicine_timing: [],
  medicine_description: "",
  medication_instruction: "",
  routeOption: [],
  formOption: [],
  strengthOption: [],
};
export const partPrnField = { medicine_name: "", description: "" };

export const medImageDimensions = { maxWidth: "170px", maxHeight: "96px", objectFit: "contain" };

export const minimumThreeHoursRegex = /^(?:[0-9]{3,}|[3-9]):[0-5][0-9]$/;

export const incidentAdminQuestions = [
  { label: "Is this a reportable incident to NDIS", name: "is_this_a_reportable_incident_to_ndis", type: "select" },
  { label: "Accident/Incident Investigation results: (Why did it occur?)", name: "incident_investigation_results", type: "textarea" },
  {
    label: "Corrective/Preventive action recommended/taken: (What did you put in place to prevent it happening again?)",
    name: "preventive_action",
    type: "textarea",
  },
  { label: "Other parties advise about the incident (Date and contact method)", name: "other_parties_advise_about_the_incident", type: "textarea" },
  { label: "Reviewed By", name: "review_by", type: "text" },
];

export const filePermissions = [
  { label: "Read Only", value: "read" },
  { label: "Read & Write", value: "write" },
];

export const imageSupportList = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

export const access = {
  dashboard: {
    view: false,
  },
  service: {
    view: false,
    add: false,
    remove: false,
    extra: {
      priceDetail: false,
      serviceItems: false,
    },
  },
  participant: {
    view: false,
    add: false,
    remove: false,
    extra: {
      funding: false,
      email: false,
      folders: false,
      medication: {
        view: false,
        add: false,
        remove: false,
        extra: {
          logs: false,
          report: false,
        },
      },
      calendar: false,
      invoiceContacts: false,
    },
  },
  calendar: {
    view: false,
  },
  employee: {
    view: false,
    add: false,
    remove: false,
    extra: {
      email: false,
      calendar: false,
      availability: false,
      trainingDocuments: false,
      requiredDocuments: false,
      addUserDocuments: false,
      employeesExpireDocuments: false,
      timeSheet: false,
      deleteTimeSheet: false,
      report: true,
    },
  },
  task: {
    view: false,
    add: false,
    remove: false,
    extra: {
      logs: false,
      report: false,
      clockinRestriction: false,
      invoice: false,
      assignTaskToEmployees: false,
    },
  },
  shift: {
    view: false,
    add: false,
    remove: false,
    extra: {
      assignShift: false,
      report: false,
      logs: false,
    },
  },
  openShift: {
    view: false,
    add: false,
    remove: false,
    extra: {
      assignShift: false,
    },
  },
  incidentReport: {
    view: false,
    extra: {
      formSettings: false,
      review: false,
      email: false,
      logs: false,
    },
  },
  feedback: {
    view: false,
    extra: {
      formSettings: false,
      review: false,
      // email: false,
      // logs: false,
    },
  },
  vehicleRegister: {
    view: false,
    add: false,
    remove: false,
    extra: {
      logs: false,
      serviceRecord: false,
    },
  },
  riskAssessment: {
    view: false,
    add: false,
    remove: false,
  },
  template: {
    view: false,
    add: false,
    remove: false,
  },
  notesTemplate: {
    view: false,
    add: false,
    remove: false,
  },
  medication: {
    view: false,
    add: false,
    remove: false,
    extra: {
      prescriber: false,
      logs: false,
    },
  },
  hazardReport: {
    view: false,
    extra: {
      review: false,
      email: false,
    },
  },
  trainingLinks: {
    view: false,
    add: false,
    remove: false,
    extra: {
      assign: false,
    },
  },
  companyPolicy: {
    view: false,
    add: false,
    remove: false,
  },
  invoice: {
    view: false,
    add: false,
    extra: {
      logs: false,
      bulkExport: false,
    },
  },
  email: {
    view: false,
    extra: {
      addressBook: false,
      signature: false,
    },
  },
  noticeBoard: {
    view: false,
    add: false,
    remove: false,
  },
  report: {
    view: false,
    add: false,
    remove: false,
    extra: {
      logs: false,
    },
  },
  location: {
    view: false,
    add: false,
    extra: {
      assign: false,
      register: false,
    },
  },
  switchAccount: {
    view: false,
  },
};
